<template>
  <v-dialog content-class="img-dialog" :value="open" scrollable eager persistent>
    <v-btn fixed icon top right @click.prevent="_close()" color="white">
      <v-icon class="fi fi-rr-cross-small"></v-icon>
    </v-btn>
    <div
      style="width: 90%; max-height: 90vh; margin-right: auto; margin-left: auto;"
      class="d-flex align-center justify-center flex-wrap"
    >
      <div v-show="isVimeo" id="global_vimeo_player" style="width: 100%;">
        <p class="colorWhite--text text-center">{{ $t('message.videoNotReady') }}</p>
      </div>
      <video
        v-if="isVideo && !isVimeo"
        id="global_video_player"
        :src="singleMedia"
        width="100%"
        height="100%"
        controls
      ></video>

      <template v-if="!isVideo && multiMedia.length">
        <v-img
          v-for="imgUrl in multiMedia"
          :src="imgUrl"
          contain
          style="max-height: 100%; width: 50%; max-width: 50%"
        ></v-img>
      </template>
      <v-img
        v-if="!isVideo && singleMedia"
        :src="singleMedia"
        contain
        style="max-height: 100%; max-width: 100%;"
      ></v-img>
    </div>
  </v-dialog>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Player from '@vimeo/player'

export default {
  name: 'MediaPopup',
  computed: {
    ...mapState({
      media: state => state.MediaPopupHelper.media,
      isVideo: state => state.MediaPopupHelper.isVideo,
      open: state => state.MediaPopupHelper.open,
    }),
    isVimeo() {
      if (this.isVideo && this.media) {
        return this.media.indexOf('vimeo.com') > -1
      }

      return false
    },
    multiMedia() {
      if (!this.isVideo && this.media && Array.isArray(this.media) && this.media.length > 1) {
        return this.media
      }

      return []
    },
    singleMedia() {
      if (this.media) {
        if (typeof this.media === 'string') {
          return this.media
        } else if (Array.isArray(this.media) && (this.media.length === 1 || this.isVideo)) {
          return this.media[0]
        }
      }

      return ''
    },
  },
  watch: {
    open: {
      handler(val) {
        if (val === true) {
          if (this.isVimeo) {
            this._setVimeoPlayer()
          }
        }
      },
    },
  },
  data: () => ({
    vimeoPlayer: null,
  }),
  methods: {
    ...mapActions(['closeMediaPopup']),
    _close() {
      if (document.getElementById('global_video_player')) {
        document.getElementById('global_video_player').pause()
        document.getElementById('global_video_player').currentTime = 0
      }

      if (this.vimeoPlayer !== null) {
        try {
          this.vimeoPlayer.destroy()
        } catch {}

        this.vimeoPlayer = null
      }
      this.closeMediaPopup()
    },

    async _setVimeoPlayer() {
      try {
        const config = {
          autoplay: true,
          url: this.singleMedia,
          responsive: true,
          maxwidth: 800,
        }
        if (this.vimeoPlayer === null) {
          this.vimeoPlayer = new Player('global_vimeo_player', config)
        } else {
          await this.vimeoPlayer.loadVideo(config)
        }
      } catch (err) {
        this.$common.error(`error: ${err}`)
        window.open(this.singleMedia, '_blank')
        this._close()
      }
    },
  },
  beforeDestroy() {
    if (this.vimeoPlayer !== null) {
      try {
        this.vimeoPlayer.destroy()
      } catch {}
      this.vimeoPlayer = null
    }
  },
}
</script>
<style lang="scss" scoped>
::v-deep #global_vimeo_player {
  &[data-vimeo-initialized="true"]>p {
    display: none !important;
  }
}
</style>
